export default {
  "content": "<path d=\"M25.293 9.293a1 1 0 011.497 1.32l-.083.094-16 16a1 1 0 01-1.497-1.32l.083-.094 16-16z\" fill=\"currentColor\"/><path d=\"M26 26L10 10\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/>",
  "attrs": {
    "width": "36",
    "height": "36",
    "viewBox": "0 0 36 36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};